import React from 'react';
import { SelectItem } from '../Select.types';

interface CategoryListProps {
  name: string;
  sub: string;
  selectableTitle: boolean;
  onClickSelectableTitle?: () => void;
  onSelect: (item: SelectItem[]) => void;
  defaultTitle: string;
  list: SelectItem[];
}

export const CategoryList = ({
  name,
  sub,
  selectableTitle,
  onClickSelectableTitle,
  onSelect,
  defaultTitle,
  list,
}: CategoryListProps) => {
  return (
    <div>
      <li key={-1} onClick={onClickSelectableTitle} className={selectableTitle ? '' : 'inactive'}>
        {defaultTitle}
      </li>
      {...list.map((item, index) => (
        <li key={index} onClick={() => onSelect(item[sub])}>
          <span>{item[name]}</span>
          <i className='icon-angle-right' />
        </li>
      ))}
    </div>
  );
};
